import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { UserPermissions } from "generated/graphql";
import { useCheckPermissions } from "hooks/authentication/useCheckPermissions";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import ListArchivedEmployees from "modules/OrganizationEmployees/ListArchivedEmployees";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import Footer from "partials/Footer/Footer";
import { Link } from "react-router-dom";

export default function ArchivedEmployeesPage() {
  const { hasPermissions } = useCheckPermissions();
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Archived Employees
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6} display="flex" justifyContent="flex-end">
              {hasPermissions(UserPermissions.MANAGE_EMPLOYEES) && (
                <MDButton
                  component={Link}
                  type="button"
                  to="/organization/employees"
                  color="secondary"
                  variant="outlined"
                >
                  Back to Employees
                </MDButton>
              )}
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <ListArchivedEmployees />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
